import { render, staticRenderFns } from "./InstitutionsExportPage.vue?vue&type=template&id=6f05a2df&"
import script from "./InstitutionsExportPage.vue?vue&type=script&lang=js&"
export * from "./InstitutionsExportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports